<div id="footer-paper-view">
  <div class="contact-info">
    <span class="info-header">CMP Contact :</span>
    <span class="info-header" style="color: #000">
      UI : Shetty, Sunil</span>
  </div>
  <div class="update-info">
    <span>Last update: 15-10-2026</span>
    <mat-divider [vertical]="true"></mat-divider>
    <span>© 2026 Chevron Corporation</span>
    <mat-divider [vertical]="true"></mat-divider>
    <span>Company Confidential</span>
    <mat-divider [vertical]="true"></mat-divider>
    <span>Contact: <a class="feedback-form">Feedback</a></span>
  </div>
  <div style="right: 1%; position: relative">
    <img src="../../assets/img/chevron-logo-black.png" width="70" height="70" />
  </div>
</div>